<template>
    <div :class="classes" @click="toggleEditMode">
        <div v-if="!editMode">
            <CompassSkeleton v-if="loading" size="x-large" />
            <div v-else class="edit-single-user__content">
                <CompassAvatar
                    :initials="userInitials"
                    size="small"
                    :colorType="randAvatarColorFullname(data.name)"
                    :stateBadge="stateBadge"
                    :photo="userPhoto"
                />
                <div>{{ data.name }}</div>
            </div>
        </div>
        <div v-else>
            <CompassSelect
                v-model="selectedUser"
                filterable
                forceSelectOpen
                @update:value="handleValueUpdate"
                @close="editMode = false"
            >
                <CompassDropdownSelectOption
                    v-for="item in filteredStaff"
                    :key="item.id"
                    :label="`${item.firstname} (${item.lastname})`"
                    :value="item.id"
                    type="avatar"
                    :avatar="{
                        photo: item.avatar,
                        initials: getInitials(item.firstname, item.lastname),
                        state: 'default',
                        colorType: randAvatarColorFullname(`${item.firstname} ${item.lastname}`),
                    }"
                />
            </CompassSelect>
        </div>
    </div>
</template>
<script>
import { randAvatarColorFullname } from 'utils/avatar';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('staffs');

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        stateBadge: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'deactivated', 'removed', 'owner'].includes(value),
        },
    },
    data() {
        return {
            editMode: false,
            selectedUser: parseInt(this.data.id),
        };
    },
    computed: {
        ...mapGetters({
            staff: 'getStaffs',
        }),
        classes() {
            return {
                'edit-single-user': true,
                'edit-single-user--editable': this.canEdit,
            };
        },
        userInitials() {
            if (this.data.avatar.type === 'intials') {
                return this.data.avatar.value;
            }
            return this.getInitials(this.data.firstname, this.data.lastname);
        },
        userPhoto() {
            if (this.data.avatar.type === 'picture') {
                return this.data.avatar.value;
            }
            return null;
        },
        filteredStaff() {
            return this.staff.filter((item) => item.status === 'ok');
        },
    },
    watch: {
        data(newValue) {
            this.selectedUser = parseInt(newValue.id);
        },
    },
    methods: {
        randAvatarColorFullname,
        toggleEditMode() {
            if (!this.editMode && this.canEdit && this.staff?.length > 0) {
                this.editMode = true;
            }
        },
        getInitials(firstname, lastname) {
            return `${firstname[0]}${lastname[0]}`;
        },
        handleValueUpdate(value) {
            this.$emit('update', value);
            this.editMode = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-single-user {
    border-radius: 2px;

    &--editable {
        .edit-single-user__content {
            cursor: pointer;

            &:before {
                content: '';
                background: var(--colors-common-background-primary-hover-alt);
                border-radius: 2px;
                bottom: 0;
                display: none;
                left: -4px;
                position: absolute;
                right: -4px;
                top: 0;
            }

            &:hover {
                &:before {
                    display: block;
                }
            }
        }
    }

    &--editable {
        .edit-single-user__content {
            cursor: pointer;
        }
    }

    &__content {
        align-items: center;
        cursor: default;
        display: flex;
        gap: var(--spacing-1);
        padding: var(--spacing-0);
        position: relative;
        user-select: none;

        &::v-deep {
            .compass-avatar {
                flex-shrink: 0;
            }
        }
    }

    &::v-deep {
        .compass-select {
            width: 100%;
        }

        .compass-skeleton {
            .compass-skeleton__line--x-large {
                height: 40px;
            }
        }
    }
}
</style>
